import { HttpHeaders } from '@angular/common/http'
import { Injectable, OnDestroy } from '@angular/core'
import { Subject, takeUntil } from 'rxjs'
import { AbstractRestService } from '../abstract-rest/abstract-rest.service'
import { AuthService } from '../auth/auth.service'
import { ChatUserData } from '../auth/auth.service.fixtures'

@Injectable({
  providedIn: 'root',
})
export abstract class AbstractChatService
  extends AbstractRestService
  implements OnDestroy
{
  readonly destroySubject: Subject<void> = new Subject<void>()
  chatUserData: ChatUserData = undefined

  constructor(authService: AuthService) {
    super()
    authService.chatUserData
      .pipe(takeUntil(this.destroySubject))
      .subscribe((chatUserData) => {
        this.chatUserData = chatUserData
        this.didFetchUserData()
      })
  }

  override ngOnDestroy() {
    super.ngOnDestroy()
    this.destroySubject.next()
    this.destroySubject.complete()
  }

  didFetchUserData() {
    // abstract
  }

  getAuthHeaders(): HttpHeaders {
    return new HttpHeaders()
      .set('X-User-Id', this.chatUserData?.userId)
      .set('X-Auth-Token', this.chatUserData?.token)
  }
}
